var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConstruction2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 170 170",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f7f7f7;}.cls-2{fill:none;stroke:#b53729;stroke-width:4px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Circle"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 85,
    cy: 85,
    r: 85
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 68.82,
    y1: 64.16,
    x2: 68.82,
    y2: 70.78
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "97.24 51.41 97.24 34.95 97.24 33.53 66.82 33.53"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 51.5,
    y: 71.18,
    width: 27.63,
    height: 57.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 56.01,
    y1: 86.07,
    x2: 59.71,
    y2: 86.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 63.41,
    y1: 86.07,
    x2: 67.11,
    y2: 86.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 70.8,
    y1: 86.07,
    x2: 74.51,
    y2: 86.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 56.01,
    y1: 93.07,
    x2: 59.71,
    y2: 93.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 63.41,
    y1: 93.07,
    x2: 67.11,
    y2: 93.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 70.8,
    y1: 93.07,
    x2: 74.51,
    y2: 93.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 56.01,
    y1: 100.07,
    x2: 59.71,
    y2: 100.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 63.41,
    y1: 100.07,
    x2: 67.11,
    y2: 100.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 70.8,
    y1: 100.07,
    x2: 74.51,
    y2: 100.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 56.01,
    y1: 107.07,
    x2: 59.71,
    y2: 107.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 63.41,
    y1: 107.07,
    x2: 67.11,
    y2: 107.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 70.8,
    y1: 107.07,
    x2: 74.51,
    y2: 107.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 56.01,
    y1: 114.07,
    x2: 59.71,
    y2: 114.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 63.41,
    y1: 114.07,
    x2: 67.11,
    y2: 114.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 70.8,
    y1: 114.07,
    x2: 74.51,
    y2: 114.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 56.01,
    y1: 121.07,
    x2: 59.71,
    y2: 121.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 63.41,
    y1: 121.07,
    x2: 67.11,
    y2: 121.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 70.8,
    y1: 121.07,
    x2: 74.51,
    y2: 121.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 93.68,
    y: 65.1,
    width: 25.63,
    height: 63.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 97.23,
    y: 58.63,
    width: 18.54,
    height: 6.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 99.02,
    y1: 72.61,
    x2: 113.98,
    y2: 72.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 99.02,
    y1: 80.5,
    x2: 113.98,
    y2: 80.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 99.02,
    y1: 88.39,
    x2: 113.98,
    y2: 88.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 99.02,
    y1: 96.28,
    x2: 113.98,
    y2: 96.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 99.02,
    y1: 104.17,
    x2: 113.98,
    y2: 104.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 99.02,
    y1: 112.06,
    x2: 113.98,
    y2: 112.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 99.02,
    y1: 119.94,
    x2: 113.98,
    y2: 119.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 106.5,
    y1: 57.74,
    x2: 106.5,
    y2: 48.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 38.39,
    y1: 63.16,
    x2: 48.39,
    y2: 63.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 34.46,
    y1: 63.16,
    x2: 30.39,
    y2: 63.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 91.7,
    y1: 40.74,
    x2: 87.63,
    y2: 40.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 130.2,
    y1: 128.29,
    x2: 40.47,
    y2: 128.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.55,54.68a5.24,5.24,0,1,1-1-7.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.19,55.11A8.62,8.62,0,1,1,75,46.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 77.13,
    cy: 51.49,
    r: 5.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 51.2,
    y1: 78.91,
    x2: 66.87,
    y2: 78.91
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstruction2);
export default __webpack_public_path__ + "static/media/construction-2.534056d8b477ef8456ab6c47e195b57b.svg";
export { ForwardRef as ReactComponent };